<div class="row">
  <div class="col-md-6">
    <finder-search-left [initial]="initial" [searchType]="searchType" [id]="id"></finder-search-left>
  </div>

  <div class="col-md-6">
    <finder-search-right [searchType]="searchType" [id]="id" [main]="main"></finder-search-right>
  </div>
</div>
